import * as React from "react";
import { RouteChildrenProps } from "react-router";

export default class NotFoundPage extends React.Component<RouteChildrenProps, {}> {
    render() {
        return (
            <div>
                <h2>このページは存在しません</h2>
            </div>
        );
    }
}
